/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { EvidenceFile } from '../survey/question/questionInterfaces';
import { EvidenceContainer } from './EvidenceContainer';
import './FileListContainer.scss';
import { HandleFileDescriptionFn } from '../../types/file';

export interface FileListContainerProps {
  files: EvidenceFile[];
  title?: string;
  existingFiles?: EvidenceFile[];
  allowToggle?: boolean;
  handleFileRemoved?: (i: number) => void;
  handleExistingFileRemoved?: (data: any) => void;
  handleFileDescriptionAdd?: HandleFileDescriptionFn;
  details?: {
    loaded: boolean,
    data: any
  };
  saving?: boolean;
}

export const FileListContainer = (props: FileListContainerProps) => {
  const {
    allowToggle,
    handleExistingFileRemoved,
    handleFileRemoved,
    title,
  } = props;

  const sizeClass = 'col-12 col-lg-6';

  return (
    <div className='fileListContainer my-2'>
      <div className={`fileList current-files ${sizeClass}`}>
        {props.files.length > 0 && title ? <h5>{title}</h5> : <></>}
        <EvidenceContainer
          {...props}
          allowToggle={true}
          isLoaded={true}
          toggleFile={handleFileRemoved}
          saving={!!props.saving}
        />
      </div>
      <div className={`fileList existingFiles ${sizeClass}`}>
        {props.existingFiles && props.existingFiles.length> 0 ? <h5>Existing evidence</h5> : <></>}
        <EvidenceContainer
          files={props.existingFiles ?? []}
          toggleFile={(i, file) => handleExistingFileRemoved?.({ file })}
          allowToggle={allowToggle ?? false}
          isLoaded={true}
          saving={!!props.saving}
          handleFileDescriptionAdd={props.handleFileDescriptionAdd}
        />
      </div>
    </div>
  );
};
